var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMakeup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5699 14.3834L19.9849 4.98002C20.2918 4.66321 20.6587 4.41063 21.0642 4.23699C21.4697 4.06334 21.9056 3.97211 22.3467 3.96861C22.7878 3.96511 23.2252 4.0494 23.6333 4.21658C24.0415 4.38376 24.4124 4.63048 24.7243 4.94238C25.0362 5.25427 25.2829 5.62511 25.4501 6.03329C25.6172 6.44148 25.7015 6.87884 25.698 7.31992C25.6945 7.76099 25.6033 8.19697 25.4297 8.60244C25.256 9.00791 25.0034 9.37479 24.6866 9.68169L15.2833 19.1084",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24836 17.9301C6.31169 17.9301 4.74836 19.5051 4.74836 21.4534C4.74836 23.0051 1.83169 23.2267 2.41503 23.8101C3.67503 25.0934 5.32003 26.1667 7.08169 26.1667C9.64836 26.1667 11.7484 24.0667 11.7484 21.4534C11.7499 20.9922 11.6606 20.5353 11.4855 20.1086C11.3105 19.682 11.0531 19.294 10.7281 18.9668C10.4031 18.6397 10.0168 18.3797 9.59133 18.2018C9.16586 18.0239 8.70952 17.9316 8.24836 17.9301Z",
    fill: "#FF8B63",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMakeup);
export default __webpack_public_path__ + "static/media/Icon-Makeup.b1a8d3f92ab02c2e24c152afa7b19857.svg";
export { ForwardRef as ReactComponent };